import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { defaultRoutes } from 'components/MainRouter/constants';

const MenuSportLink = props => {
  const { sportUrlName, children, className, active } = props;

  const linkClassName = cx(className, { active });

  const sportPrematchUrl = `${defaultRoutes.sportPrematch}/${sportUrlName}`;

  return (
    <Link to={sportPrematchUrl} className={linkClassName}>
      {children}
    </Link>
  );
};

export default MenuSportLink;

MenuSportLink.propTypes = {
  sportUrlName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  active: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
};
